// Unica configurazione Mapbox: token pubblico (limitato ai domini nell'account Mapbox del cliente).
// Costante nel codice e non variabile d'ambiente: le variabili frontend sono fissate al build.
export const MAPBOX_TOKEN = 'pk.eyJ1IjoiY3VyYWNoZWNrMDFtYXBweSIsImEiOiJjbW92a2Y3MHAwMDBvMnBzYnV0b3o1aWplIn0.mHR0Z1-LhFKlq_L4Q4JB9Q';
export const MAP_STYLE = 'mapbox://styles/mapbox/streets-v12';
